module.exports = __webpack_public_path__ + "static/img/wall-conveyor-perpendicular_256.7fb7a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-perpendicular_256.png
// module id = UtxJ
// module chunks = 0